import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CartBox = (props: IconProps) => {
  const { size = 'md', stroke = '#9696a0', ...rest } = props;

  return (
    <svg
      fill="none"
      stroke={stroke}
      viewBox="0 0 62 68"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
      stroke-width="2.909"
    >
      <path d="M2 13.636h58" />
      <path d="M60 66H2V13.636L13.6 2h34.8L60 13.636z" strokeLinecap="square" />
      <path d="M45.5 28.182c0 8-6.525 14.545-14.5 14.545s-14.5-6.545-14.5-14.545" strokeLinecap="square" />
    </svg>
  );
};

CartBox.displayName = 'CartBox';
